import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { faqByLang } from "../i18n/faq_i18n";
import { useLang } from "../i18n/LangContext";

const FAQ = ({ onOpenForm }) => {
  const { t, lang } = useLang();
  const items = faqByLang[lang] || faqByLang.ru;

  return (
    <section id="faq" className="py-20 md:py-28 section-soft" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="eyebrow mb-3">{t("faq.kicker")}</div>
          <h2 className="headline-huge text-3xl md:text-5xl text-balance">{t("faq.title")}</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl px-5 data-[state=open]:shadow-md transition" style={{ border: '1px solid rgba(201,169,110,0.25)' }} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-semibold py-5 hover:no-underline text-base" style={{ color: '#1B2A4A' }}>{f.q}</AccordionTrigger>
              <AccordionContent className="pb-5 leading-relaxed" style={{ color: '#3a4f4f' }}>{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-4">{t("faq.notFound")}</p>
          <button onClick={onOpenForm} className="btn-amber rounded-full h-12 px-7 font-semibold inline-flex items-center" data-testid="faq-ask-expert-btn">{t("cta.askExpert")}</button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
